<template>
	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="twelve()">竞品客户信息</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div>
		<div class="main">
			<div class="main_title">
				<span>经营情况</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="Operation">
					<div class="Operation_select"><label><span class="Required">*</span>工厂所属:</label>
						<select v-model="BasFrom.fac_from">
							<option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
							</option>
						</select>
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>工厂面积:</label>
						<input type="text" v-model="BasFrom.fac_area" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>上一年营业额(万元):</label>
						<input type="text" v-model="BasFrom.gys_sales" oninput="value=value.replace(/[^0-9.]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>注册资金(万元):</label>
						<input type="text" v-model="BasFrom.gys_zczj" oninput="value=value.replace(/[^0-9.]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>纳税额(万元):</label>
						<input type="text" v-model="BasFrom.tax_amt" oninput="value=value.replace(/[^0-9.]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>营业收入(万元):</label>
						<input type="text" v-model="BasFrom.yysr_amt" oninput="value=value.replace(/[^0-9.]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>开模周期:</label>
						<input type="text" v-model="BasFrom.cycle_km" oninput="value=value.replace(/[^\d]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>打样周期 :</label>
						<input type="text" v-model="BasFrom.cycle_dy" oninput="value=value.replace(/[^\d]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>产品报价回复周期:</label>
						<input type="text" v-model="BasFrom.cycle_bj" oninput="value=value.replace(/[^\d]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>订单周期 :</label>
						<input type="text" v-model="BasFrom.cycle_dd" oninput="value=value.replace(/[^\d]/g,'')" />
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>是否有最小起订量:</label>
						<select v-model="BasFrom.min_yn" filterable allow-create placeholder="请选择">
							<option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</option>
						</select>
					</div>
					<div class="Operation_select"><label><span class="Required">*</span>最小起订量:</label>
						<input type="text" v-model="BasFrom.min_prod" oninput="value=value.replace(/[^\d]/g,'')" />
					</div>
					<div class="Operation_input"><label><span class="Required">*</span>半年流水额（万元）:</label>
						<input type="text" v-model="BasFrom.jh_address" />
					</div>
				</div>
				<div class="Operation_button">
					<button type="button" @click="openBas_info()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff"
						@click="addUser_Gys()"><span>保存</span></button>
					<button type="button" @click="nextPersonnel_info()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>

</template>


<script>
	import {
		addGys,
		getGhDl,
		getGys,
		getGhType,
		getProvince,
		getCity
	} from '../api/LoginApi'
	import {
		goBack,
		Transformation
	} from '../utils/Transformation'
	import {
		getThisYearMonthDays
	} from '../utils/date'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'
	import 'vue-multiselect/dist/vue-multiselect.min.css';
	import Multiselect from 'vue-multiselect'
	export default {
		components: {
			Multiselect
		},
		name: 'GysBasic',
		data: function() {
			return {
				BasFrom: {
					gys_no: localStorage.getItem('userName'),
					name_all: '',
					name_jc: '',
					gys_ghdl: '',
					gh_type: '',
					gys_address: '',
					comp_phone: '',
					comp_tax: '',
					fac_address: '',
					fac_phone: '',
					fac_tax: '',
					gys_provnice: '',
					gys_city: '',
					contact_man: '',
					contact_num: '',
					contact_zw: '',
					contact_man1: '',
					contact_num1: '',
					contact_zw1: '',
					fac_from: '',
					fac_area: '',
					gys_sales: '',
					gys_time: '',
					tax_amt: '',
					gys_zczj: '',
					yysr_amt: '',
					gys_jynx: '',
					gys_mail: '',
					gys_yg: '',
					yg_yf: '',
					yg_js: '',
					yg_sc: '',
					pay_specs: '',
					pay_time: '',
					pay_prom: '',
					bank_name: '',
					bank_num: '',
					cnaps_code: '',
					gys_tax: '',
					cycle_km: '',
					cycle_dy: '',
					cycle_bj: '',
					cycle_dd: '',
					jh_address: '',
					min_yn: '',
					min_prod: ''
				},
				options: [{
					value: '是',
					label: '是'
				}, {
					value: '否',
					label: '否'
				}],
				//工厂所属列表
				options3: [{
					value: '租赁',
					label: '租赁'
				}, {
					value: '自有',
					label: '自有'
				}],
				//账期规范列表
				options4: [{
						value: '月结算',
						label: '月结算'
					}, {
						value: '货到付款',
						label: '货到付款'
					},
					{
						value: '预付款',
						label: '预付款'
					}, {
						value: '其他',
						label: '其他'
					}
				],
				//账期列表
				options5: [{
						value: '15天',
						label: '15天'
					}, {
						value: '30天',
						label: '30天'
					},
					{
						value: '45天',
						label: '45天'
					}, {
						value: '60天',
						label: '60天'
					},
					{
						value: '75天',
						label: '75天'
					}, {
						value: '90天',
						label: '90天'
					}
				],
				//税率列表
				options6: [{
						value: '增值税专用票13%',
						label: '增值税专用票13%'
					}, {
						value: '增值税专用票3%',
						label: '增值税专用票3%'
					},
					{
						value: '普通发票3%',
						label: '普通发票3%'
					}, {
						value: '无发票',
						label: '无发票'
					}
				],
				optionsGhdl: [], // 供货大类列表
				optionsGhType: [], // 供货小类列表
				optionsProvNice: [], // 省份列表
				optionsCity: [], // 城市列表
				ghdl_data: [], // 供货大类数据存储
				ghtype_data: [], // 供货小类数据存储
			}
		},
		created() {
			this.getBasic()
		},
		mounted() {
			// 默认时间
			this.BasFrom.gys_time = getThisYearMonthDays(new Date, 'yyyy-mm-dd')
			this.BasFrom.gys_jynx = this.BasFrom.gys_time.substring(0, 4)
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {

			// 上一个页面
			openBas_info() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			// 下一步
			nextPersonnel_info: function() {
				if (this.BasFrom.bill_status != '已审核') {  
					//先保存数据
					this.addUser_Gys();
					const vm = this;
					// 非空校验
					if (!this.BasFrom.fac_from) {
						return messageError('工厂所属必填!')
					}
					if (!this.BasFrom.fac_area) {
						return messageError('工厂面积必填!')
					}
					if (!this.BasFrom.gys_sales) {
						return messageError('全年营业额(万元)必填!')
					}
					if (!this.BasFrom.gys_zczj) {
						return messageError('注册资金(万元)必填!')
					} 
					if (!this.BasFrom.tax_amt) {
						return messageError('纳税额(万元)必填!')
					}
					if (!this.BasFrom.yysr_amt) {
						return messageError('营业收入(万元)必填!')
					}
					if (!this.BasFrom.cycle_km) {
						return messageError('开模周期必填!')
					}
					if (!this.BasFrom.cycle_dy) {
						return messageError('打样周期必填!')
					}
					if (!this.BasFrom.cycle_bj) {
						return messageError('产品报价回复周期必填!')
					}
					if (!this.BasFrom.cycle_dd) {
						return messageError('订单周期必填!')
					}
					if (!this.BasFrom.min_yn) {
						return messageError('是否有最小生产批量必填!')
					}
					if (this.BasFrom.min_yn === '是' && !this.BasFrom.min_prod) {
						return messageError('最小生产批量必填!')
					}
					if (!this.BasFrom.jh_address) {
						return messageError('交货地点必填!')
					}
				}
				const vm = this;
				vm.$router.push({
					path: '/ProductsCapacity'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity'
				})
		    },
			twelve() {
				const vm = this
				vm.$router.push({
					path: '/CompetitorcustInfo'
				})
			},
			// 窗体加载查询数据
			getBasic: function() {
				// 查询所有数据
				getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							this.BasFrom = res
							// 供货大类转为数组渲染页面
							this.ghdl_data = JSON.parse(res.gys_ghdl)
							// 供货小类转为数组渲染页面
							this.ghtype_data = JSON.parse(res.gh_type)
							// 查询时给供货小类存起来，必要材料需要根据供货小类查询
							console.log('供货小类3: ', res.gh_type);
							localStorage.setItem('gh_type', JSON.parse(res.gh_type).map((obj)=>{return "'"+obj.name+"'"}).join(","));
							// console.log('基本信息', res)
						}
						this.upGhDl()
						this.upProvNice()
					}),
					//  查询供货大类列表
					getGhDl().then(res => {
						res.forEach(element => {
							this.optionsGhdl.push({
								language: element.gys_ghdl,
								name: element.gys_ghdl
							});
						})
					})
				//  查询省份列表
				getProvince().then(res => {
					res.forEach(element => {
						this.optionsProvNice.push({
							value: element.province,
							label: element.province
						});
					})
				})
			},
			//供货大类修改时触发
			upGhDl: function() {
				//当供货大类不为空时才查询供货小类
				if (this.ghdl_data.length > 0) { //
					// 查询供货小类
					getGhType(this.ghdl_data.map(item => encodeURIComponent(item.name.replace("/",",")))).then(res => {
						// 清空供货小类数据
						this.optionsGhType.splice(0, this.optionsGhType.length)
						res.forEach(type => {
							this.optionsGhType.push({
								language: type.gh_type,
								name: type.gh_type
							})
						})
					})
				} else {
					//清空供货小类数据
					this.optionsGhType.splice(0, this.optionsGhType.length)
				}
			},
			//省份修改时触发
			upProvNice: function() {
				// 查询城市
				if (this.BasFrom.gys_provnice) {
					getCity(this.BasFrom.gys_provnice).then(res => {
						// 清空城市列表数据
						this.optionsCity.splice(0, this.optionsCity.length)
						res.forEach(type => {
							this.optionsCity.push({
								value: type.city,
								label: type.city
							})
						})
					})
				} else {
					// 清空城市列表数据
					this.optionsCity.splice(0, this.optionsCity.length)
				}
			},
			//保存数据
			addUser_Gys: function() {
				// 把供货大类转为json数据存到数据库
				this.BasFrom.gys_ghdl = JSON.stringify(this.ghdl_data)
				// 把供货小类转为json数据存到数据库
				this.BasFrom.gh_type = JSON.stringify(this.ghtype_data)
				// 当时间不为空时将时间格式转换 否则传入空
				this.BasFrom.gys_time = this.BasFrom.gys_time ? Transformation(this.BasFrom.gys_time) : ''
				// 获取当前年份，获取成立时间年份
				let yy = new Date().getFullYear()
				let gys_yy = this.BasFrom.gys_time.slice(0, 4)
				//经营年限=当前年份-成立时间
				let gys_jynx = yy - gys_yy
				this.BasFrom.gys_jynx = gys_jynx

				if (this.BasFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}

				// 非空校验
				if (!this.BasFrom.fac_from) {
					return messageError('工厂所属必填!')
				}
				if (!this.BasFrom.fac_area) {
					return messageError('工厂面积必填!')
				}
				if (!this.BasFrom.gys_sales) {
					return messageError('全年营业额(万元)必填!')
				}
				if (!this.BasFrom.gys_zczj) {
					return messageError('注册资金(万元)必填!')
				}
				if (!this.BasFrom.tax_amt) {
					return messageError('纳税额(万元)必填!')
				}
				if (!this.BasFrom.yysr_amt) {
					return messageError('营业收入(万元)必填!')
				}
				if (!this.BasFrom.cycle_km) {
					return messageError('开模周期必填!')
				}
				if (!this.BasFrom.cycle_dy) {
					return messageError('打样周期必填!')
				}
				if (!this.BasFrom.cycle_bj) {
					return messageError('产品报价回复周期必填!')
				}
				if (!this.BasFrom.cycle_dd) {
					return messageError('订单周期必填!')
				}
				if (!this.BasFrom.min_yn) {
					return messageError('是否有最小生产批量必填!')
				}
				if (this.BasFrom.min_yn === '是' && !this.BasFrom.min_prod) {
					return messageError('最小生产批量必填!')
				}
				if (!this.BasFrom.jh_address) {
					return messageError('交货地点必填!')
				}
				addGys(this.BasFrom).then(res => {
					if (res.code === 200) { 
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			}
		}
	}
</script>


<style scoped>
	@import "../css/Main.css";
</style>



// WEBPACK FOOTER //
// src/components/Operation.vue